const t = (r) => typeof r == "string" ? r.trim() : "";
export {
  t as normalizeVideoId
};
